const initialState = {
  about: null,
  isLoading: null,
  isError: null,
};

export default initialState;
